import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';

const ClearIndicator = React.memo((props) => {
    const onClick = (e) => {
        e.stopPropagation();
        props.selectProps.onChange(null, {
            action: 'clear',
        });
    };

    const innerProps = { ...props.innerProps, onMouseDown: onClick };

    let icon = <Icon name="closeSmall" size="large" />;
    if (props?.selectProps?.clearIcon) {
        icon = props?.selectProps?.clearIcon;
    }

    return (
        components.ClearIndicator && (
            <components.ClearIndicator {...props} innerProps={innerProps}>
                {icon}
            </components.ClearIndicator>
        )
    );
});

ClearIndicator.displayName = 'ClearIndicator';

export default ClearIndicator;
